export const OVERVIEW_TAB_OPTIONS = [
  {
    id: 'overview',
    handler: 'tableauReportHandler',
    value: 'Overview',
    viewUrl: '/views/CrossViewDashboard-Overview/Overview',
    demoViewUrl: '/views/DemoCrossViewDashboard-Overview/Overview',
  },
];

export const DELIVERY_TAB_OPTIONS = [
  {
    id: 'publisher',
    handler: 'tableauReportHandler',
    value: 'Publishers',
    viewUrl: '/views/CrossViewDashboard-Publisher/Publisher',
    demoViewUrl: '/views/DemoCrossViewDashboard-Publisher/Publisher',
  },
  {
    id: 'network',
    handler: 'tableauReportHandler',
    value: 'Networks',
    viewUrl: '/views/CrossViewDashboard-Network/Network',
    demoViewUrl: '/views/DemoCrossViewDashboard-Network/Network',
  },
  {
    id: 'audience-demographics',
    handler: 'tableauReportHandler',
    value: 'Audience Demographics',
    viewUrl: '/views/CrossViewDashboard-AudienceDemographics/AudienceDemographics',
    demoViewUrl: '/views/DemoCrossViewDashboard-AudienceDemographics/AudienceDemographics',
  },
];

export const PERFORMANCE_TAB_OPTIONS = [
  {
    id: 'linear-performance',
    handler: 'tableauReportHandler',
    value: 'Linear Conversions',
    viewUrl: '/views/CrossViewDashboard-LinearPerformance/LinearPerformance',
    demoViewUrl: '/views/DemoCrossViewDashboard-LinearPerformance/LinearPerformance',
  },
];
